module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('Header', {
    staticClass: "black"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "slogan"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v("打造视频梦工厂")]), _vm._v(" "), _c('div', {
    staticClass: "h2"
  }, [_vm._v("懂视频·更懂你")])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "about.html"
    }
  }, [_vm._v("关于我们")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "flow.html"
    }
  }, [_vm._v("服务流程")])]), _vm._v(" "), _c('span', {
    staticClass: "active"
  }, [_vm._v("常见问题")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v("客户篇")]), _vm._v(" "), _c('div', {
    staticClass: "content clearfix"
  }, [_c('dl', [_c('dt', [_vm._v("如何发布项目？")]), _vm._v(" "), _c('dd', [_vm._v("在首页上方导航栏点击“我要拍片”或者在右侧悬浮栏点击“发布意向单”，填写项目需求并提交。我们的项目经理会在1、2天内通过您留下的联系方式联系您，和您沟通并对项目进行评估，评估过后会为您的项目匹配合适的制作人/团队。")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("我可以取消项目吗？")]), _vm._v(" "), _c('dd', [_vm._v("沟通阶段的项目可以取消项目，签订合同之后的项目以合同条款为准。")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("我可以要求退款吗？")]), _vm._v(" "), _c('dd', [_vm._v("项目立项后会签订合同，退款规则以合同条款为准。")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("我能自己选择制作人/团队吗？")]), _vm._v(" "), _c('dd', [_vm._v("我们会为您匹配合适的制作人/团队，如果您希望自己指定制作人/制作团队，我们会在给出合理建议的基础上尊重您的选择，为您联系并沟通档期，如因制作人/团队个人问题不能接项目，趣编网不承担责任。")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("如何查看项目？")]), _vm._v(" "), _c('dd', [_vm._v("登陆后在首页上方导航栏点击头像—我的项目，可以查看您正在进行的项目和历史项目，点击进入项目详情可以查看项目状态、项目信息以及相关文件。")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("制作人可能在世界各地，如何保证拍摄质量？")]), _vm._v(" "), _c('dd', [_vm._v("我们设有监制团队，全程监管项目拍摄制作，充分保障视频质量。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "h1"
  }, [_vm._v("制作人篇")]), _vm._v(" "), _c('div', {
    staticClass: "content clearfix"
  }, [_c('dl', [_c('dt', [_vm._v("什么是制作人？")]), _vm._v(" "), _c('dd', [_vm._v("“制作人”是平台用户经过认证后的身份，是审核确认过具有一定能力的影视从业人员。")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("如何成为制作人？")]), _vm._v(" "), _c('dd', [_vm._v("在首页点击“成为制作人”或登陆后在制作人主页点击“制作人认证”，填写资料并提交审核，我们会尽快与您联系审核您的制作人资质，通过审核后即可成为认证制作人。")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("认证制作人后我能做什么？")]), _vm._v(" "), _c('dd', [_vm._v("经过认证后，趣编网会根据您的擅长项目类型、风格、角色定位、地点等为您匹配合适的项目。"), _c('br'), _vm._v("您还可以管理您的个人主页并建立作品集，向别人展现您的专业能力、项目经验等优势，优秀的个人主页可能会吸引用户直接邀请您参与项目制作。")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("接到项目后的操作流程是什么样的？")]), _vm._v(" "), _c('dd', [_vm._v("制片人接到项目并确认→制片人组建团队→制片人制作并提交价格清单（包括人员场地器材等项目相关所有价格明细）→拍摄→验收→结算")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("我是制片人，接到项目后如何组建制作团队？")]), _vm._v(" "), _c('dd', [_vm._v("制片人接到项目并确认后，可在“我的项目”项目详情中选择合适的团队成员组建团队，提交团队后，我们的项目经理会联系各团队成员并建立群组进行沟通，项目经理会帮助进行团队的组建和协调各种问题，沟通后确定最终团队成员名单。")])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("我想要邀请趣编网上的一名制作人参与项目制作，该怎么做？")]), _vm._v(" "), _c('dd', [_vm._v("如果您是制片人且接到趣编网为您匹配的项目，您可以直接在“我的项目”项目详情中使用组建团队功能选择该制作人；"), _c('br'), _vm._v("如果您是自己的项目，您可以拨打趣编网客服电话告知您的需求，我们会帮您联系该制作人。")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68b6a7b2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/question/App.vue
// module id = 1290
// module chunks = 16